/**
 * 初期処理
 *
 */
$(window).on('load', function() {
  // 連絡方法選択時の制御
  oh_click_contact_way();

  // 物件の種類選択時の制御
  oh_click_valuation_property_type1();

  // 住所コピー
  oh_copy_address('0');
});

/**
 * 連絡方法選択時の制御
 *
 */
(function () {
  $("[id^=contact_way]").on('change',function() {
		oh_click_contact_way();
	});
}());
var oh_click_contact_way = function() {
  oh_click_contact_way_toggle_class($('#customer_address1').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
  oh_click_contact_way_toggle_class($('#customer_address2').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
};
var oh_click_contact_way_toggle_class = function ( el ) {
  // 初期化
  el.removeClass('--required');
  // クラス付与
  if ($('#contact_way4').prop('checked')) {
    el.addClass('--required');
  }
};

/**
 * 査定対象物件の物件種別選択時の制御
 *
 */
(function () {
  $("[id^=valuation_property_type1_]").on('click',function() {
		oh_click_valuation_property_type1();
	});
}());
var oh_click_valuation_property_type1 = function() {
  notice = '<span class="c-form-item__label-notice --area">おおよそで構いません</span>';

  switch ($('input[name="valuation_property_type1"]:checked').val()) {
    case '3':
      // マンションの場合
      $('#item_valuation_mansion_nm').show();
      $('#item_valuation_room_no').show();
      $('#item_mansion_nm').show();
      $('#item_room_no').show();

      // $('#valuation_address2_must').attr("style","visibility: hidden;");

      $('#label_valuation_exclusive_area').text('専有面積').append(notice);;
      $(':input[id^=valuation_property_status_]').attr("disabled","disabled");
      $(':input[id^=valuation_property_status_3]').removeAttr("disabled");

      $('#assess_current_status1').hide();
      $('#assess_current_status2').hide();
      $('#assess_current_status3').show();
      break;

    case '2':
      // 戸建の場合
      $('#item_valuation_mansion_nm').hide();
      $('#item_valuation_room_no').hide();

      if($('#copyAddress').prop('checked')) {
        $('#item_mansion_nm').hide();
        $('#item_room_no').hide();
      } else {
        $('#item_mansion_nm').show();
        $('#item_room_no').show();
      }

      oh_toggle_required('#valuation_address2', true);
      // $('#valuation_address2_must').attr("style","visibility: visible;");

      $('#label_valuation_exclusive_area').text('建物面積');
      $(':input[id^=valuation_property_status_]').attr("disabled","disabled");
      $(':input[id^=valuation_property_status_2]').removeAttr("disabled");

      $('#assess_current_status1').hide();
      $('#assess_current_status2').show();
      $('#assess_current_status3').hide();
      break;

    case '1':
      // 土地の場合
      $('#item_valuation_mansion_nm').hide();
      $('#item_valuation_room_no').hide();

      if($('#copyAddress').prop('checked')) {
        $('#item_mansion_nm').hide();
        $('#item_room_no').hide();
      } else {
        $('#item_mansion_nm').show();
        $('#item_room_no').show();
      }

      oh_toggle_required('#valuation_address2', true);

      $('#label_valuation_exclusive_area').text('土地面積');
      $(':input[id^=valuation_property_status_]').attr("disabled","disabled");
      $(':input[id^=valuation_property_status_1]').removeAttr("disabled");

      $('#assess_current_status1').show();
      $('#assess_current_status2').hide();
      $('#assess_current_status3').hide();
      break;
  }
};
var oh_toggle_required = function ( id, required ) {
  el = $(id).closest('.c-form-item__input-row').siblings('.c-form-item__label');

  // 初期化
  el.removeClass('--required');
  // クラス付与
  if (required) {
    el.addClass('--required');
  }
};

//「査定対象物件と同じ」チェック時
(function () {

  $("#copyAddress").on('click',function() {
		oh_copy_address('1');
	});

  $('#valuation_pref').bind('change',function() {
    if($('#copyAddress').prop('checked')) {
      pref = $('#valuation_pref').val();
      $('#customer_address1').val(pref);
    }
  });
  $('#valuation_city').bind('change',function() {
    if($('#copyAddress').prop('checked')) {
      pref = $('#valuation_pref').val();
      city = $('#valuation_city').val();
      $('#customer_address1').val(pref + city);
    }
  });
  $('#valuation_town').bind('change',function() {
    if($('#copyAddress').prop('checked')) {
      pref = $('#valuation_pref').val();
      city = $('#valuation_city').val();
      town = $('#valuation_town').val();
      $('#customer_address1').val(pref + city + town);
    }
  });

  $('#valuation_address2').bind('change',function() {
    if($('#copyAddress').prop('checked')) {
      $('#customer_address2').val($('#valuation_address2').val());
    }
  });
  $('#valuation_mansion_nm').bind('change',function() {
    if($('#copyAddress').prop('checked')) {
      $('#customer_mansion_nm').val($('#valuation_mansion_nm').val());
    }
  });
  $('#valuation_room_no').bind('change',function() {
    if($('#copyAddress').prop('checked')) {
      $('#customer_room_no').val($('#valuation_room_no').val());
    }
  });
}());
//--------------------------------------------------------------------------------
//住所のコピー
//--------------------------------------------------------------------------------
var oh_copy_address = function(flg) {
  if($('#copyAddress').prop('checked')) {
    $('#copyAddress').val('1');
    // $('#customer_zip_cd').val($('#valuation_zip_cd').val());
    $('#customer_address1').val($('#valuation_pref').val() +$('#valuation_city').val() +$('#valuation_town').val());
    $('#customer_address2').val($('#valuation_address2').val());
    $('#customer_mansion_nm').val($('#valuation_mansion_nm').val());
    $('#customer_room_no').val($('#valuation_room_no').val());

    $('#customer_zip_cd').attr('readonly',true);
    $('#customer_address1').attr('readonly',true);
    $('#customer_address2').attr('readonly',true);
    $('#customer_mansion_nm').attr('readonly',true);
    $('#customer_room_no').attr('readonly',true);

    if($('input[name="valuation_property_type1"]:checked').val() != 3){
      $('#item_mansion_nm').hide();
      $('#item_room_no').hide();
    }

  } else {
    $('#copyAddress').val('0');
    $('#customer_zip_cd').removeAttr('readonly',false);
    $('#customer_address1').removeAttr('readonly',false);
    $('#customer_address2').removeAttr('readonly',false);
    $('#customer_mansion_nm').removeAttr('readonly',false);
    $('#customer_room_no').removeAttr('readonly',false);
    if (flg == '1') {
      // $('#customer_zip_cd').val('');
      $('#customer_address1').val('');
      $('#customer_address2').val('');
      $('#customer_mansion_nm').val('');
      $('#customer_room_no').val('');
    }

    $('#item_mansion_nm').show();
    $('#item_room_no').show();

  }
  // バックカラー
  // require_address();
};

/**
 * ふりがな自動入力
 */
 $(function() {
  $.fn.autoKana('#customer_nm', '#customer_kn');
});
